<template>
  <div class="ovg-page">
    <div class="ovg-page__bg" aria-hidden="true" />

    <header class="ovg-header">
      <div class="ovg-header__logos">
        <img
          src="@/assets/logo_original.svg"
          alt="Samtek"
          class="ovg-header__logo-samtek"
        />
        <img
          src="@/assets/logo_asus.png"
          alt="ASUS"
          class="ovg-header__logo-asus"
        />
      </div>
      <button type="button" class="ovg-header__salir" @click="onSalir">
        Salir <font-awesome-icon icon="sign-out-alt" />
      </button>
    </header>

    <div class="ovg-subheader">
      <div class="ovg-subheader__inner">
        <h2 class="ovg-subheader__title">Registra tu equipo para ingreso</h2>
        <p class="ovg-subheader__subtitle">
          Agiliza tu atención en sucursal.<br />
          Completa los datos de tu equipo por adelantado para un ingreso rápido
          y seguro, ya sea para evaluación de garantía o presupuesto de
          reparación.
        </p>
      </div>
    </div>

    <div class="ovg-content">
      <div class="ovg-card">
        <div class="ovg-progress">
          <div class="ovg-progress__track">
            <div class="ovg-progress__fill" :style="{ width: progressWidth }" />
          </div>
          <span class="ovg-progress__label">Paso Actual: {{ stepLabel }}</span>
        </div>

        <div class="ovg-steps">
          <div class="ovg-step" :class="stepClass(1)">
            <span class="ovg-step__num">1</span>
            <span class="ovg-step__label">Tus Datos</span>
          </div>
          <div class="ovg-step" :class="stepClass(2)">
            <span class="ovg-step__num">2</span>
            <span class="ovg-step__label">Detalle y Falla</span>
          </div>
          <div class="ovg-step" :class="stepClass(3)">
            <span class="ovg-step__num">3</span>
            <span class="ovg-step__label">Resumen</span>
          </div>
        </div>

        <DatosCliente
          v-if="step === 1"
          :setDatosProvisorios="setDatosCliente"
          :datosReturn="formClient.datosProvisorios"
        />
        <GarantiaFalla
          v-if="step === 2"
          :garantiaReturn="formClient.formGarantia"
          :setDatosGarantia="setDatosEquipo"
          :guardarBoleta="setBoleta"
          :boleta="boleta"
          @goBack="regresar"
        />
        <Resumen
          v-if="step === 3"
          :datosCliente="formClient.datosProvisorios"
          :garantiaFalla="formClient.formGarantia"
          :boleta="boleta"
          @finish="cancelar"
          @goBack="regresar"
        />
      </div>
    </div>

    <!-- Botón de contacto: oculto hasta que el negocio lo habilite (mismo criterio que OVGStore) -->

    <p class="ovg-page__footer">
      © 2026 Samtek | Servicio Técnico ASUS Autorizado en Chile.
    </p>
  </div>
</template>

<script>
import DatosCliente from './Form/DatosCliente.vue'
import GarantiaFalla from './Form/GarantiaFalla.vue'
import Resumen from './Form/Resumen.vue'

const STEP_LABELS = {
  1: 'Tus Datos',
  2: 'Detalle y Falla',
  3: 'Resumen',
}

export default {
  name: 'PreIngreso',
  components: {
    DatosCliente,
    GarantiaFalla,
    Resumen,
  },
  data() {
    return {
      formClient: {
        datosProvisorios: {
          rut: null,
          nombre: null,
          apellido: null,
          email: null,
          telefono: null,
          direccion: null,
          comuna: null,
          region: null,
        },
        formGarantia: {
          tipo_servicio: null,
          reporte_falla_cliente: null,
          fecha_de_compra: null,
        },
      },
      boleta: '',
      step: 1,
    }
  },
  computed: {
    stepLabel() {
      return STEP_LABELS[this.step] || ''
    },
    progressWidth() {
      return `${(this.step / 3) * 100}%`
    },
  },
  methods: {
    stepClass(n) {
      if (this.step === n) return 'ovg-step--active'
      if (this.step > n) return 'ovg-step--done'
      return ''
    },
    setDatosCliente(datosProvisorios) {
      this.formClient.datosProvisorios = datosProvisorios
      this.step += 1
    },
    setDatosEquipo(formGarantia) {
      this.formClient.formGarantia = formGarantia
      this.step += 1
    },
    regresar() {
      this.step -= 1
    },
    cancelar() {
      this.formClient = {
        datosProvisorios: {
          rut: null,
          nombre: null,
          apellido: null,
          email: null,
          telefono: null,
          direccion: null,
          comuna: null,
          region: null,
        },
        formGarantia: {
          tipo_servicio: null,
          reporte_falla_cliente: null,
          fecha_de_compra: null,
        },
        boleta: '',
      }
      this.boleta = ''
      this.step = 1
    },
    setBoleta(boleta) {
      this.boleta = boleta
    },
    async onSalir() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        '¿Estás seguro que deseas cancelar? Se perderán los datos ingresados',
        {
          title: 'Cancelar pre-ingreso',
          okVariant: 'warning',
          okTitle: 'Sí, cancelar',
          cancelTitle: 'Volver',
          centered: true,
        }
      )
      if (confirmed) {
        this.cancelar()
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/style/portal-cliente.scss';
</style>
